import React from "react";

const Statements = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Statement of the boards, councils, committees & other bodies</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
        <p>
          The Corporation is incorporated under the Companies Act, 1956 as
          amended from time to time. Various committees as per requirement of
          Corp. are framed as per approval of the Board or by the top Management
          as per the powers delegated by the Board. Public is not entitled to
          participate in the meetings of the Board/Committee and minutes are not
          accessible to them. However two representative of the Shareholder Seed
          Growers of Haryana are on Board of the Corporation.
        </p>

        <p>
          a statement of the boards, councils, committees and other bodies
          consisting of two or more persons constituted as its part or for the
          purpose of its advice, and as to whether meetings of those boards,
          councils, committees and other bodies are open to the public, or the
          minutes of such meetings are accessible for public;
        </p>

        <p>
          There are 11 directors on the Board of Directors of which 6 are
          appointed by State Government, 3 by National Seeds Corporation Limited
          and 2 by the growers shareholders of the Corporation. The list of
          current Board of Directors is available on the website of the
          Corporation. The Board of Directors has constituted 3 sub-committees
          vis Audit Committee, Stakeholders Relationship Committee and
          Nomination and Remuneration Committee. These committees comprises of
          the Directors of the Corporations. The tenure of directors is as per
          the State Govt. orders, National Seeds Corporation orders and the
          representative of grower&rsquo;s directors is three years. In respect
          of Board of Directors, the various powers have been delegated by the
          Articles of Association as well as Companies Act subject to changes
          from time to time. In respect of Committee of Directors, powers are
          assigned by the Board of Directors and the applicable laws, rules and
          guidelines. In regard to the Shareholders meeting, the Minutes of
          opened to the General Public as per the Companies Act, 2013. In regard
          to the Board and Committee Meeting, these are available only for
          specified persons as per the Companies Act, 2013 and Rules thereunder.
          The above minutes are available at the Registered Office of the
          Company.
        </p>
      </div>
    </div>
  );
};

export default Statements;
